//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ClassFunc = require('../../../util/ClassFunc')
const Stats = require('./Stats')

/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_icehockey_PlayerStatsGroup = function() {
    // console.log('tbs_model_vo_icehockey_PlayerStatsGroup constructor')
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Stats, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_icehockey_PlayerStatsGroup.prototype = {
    /* The view object name */
    name: 'group',
    /* The view object instance */
    view: {
        get: [
            {
                name: 'stats',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/stats/:role/2',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    role: 'role',
                },
                basePath: '',
                rule: {
                    league: 'leagueName',
                    season: '$season',
                    team: 'clubTeamName',
                    matchId: 'matchId',
                    groupId: 'groupId',
                    group: 'groupName',
                    position: '$position',
                    cgp: 'cgp',
                    g: 'g',
                    a: 'a',
                    p: 'p',
                    pim: 'pim',
                    ppg: 'ppg',
                    shg: 'shg',
                    otg: 'otg',
                    gwg: 'gwg',
                    psg: 'psg',
                    sogp: 'sogp',
                    sog: 'sog',
                    sos: 'sos',
                    sosp: '$sosp',
                    gaa: '$gaa',
                    ga: 'ga',
                    w: 'w',
                    l: 'l',
                    wp: '$wp',
                    so: 'so',
                    ppga: 'ppga',
                    shga: 'shga',
                    otga: 'otga',
                    gwga: 'gwga',
                    psga: 'psga',
                    sow: 'sow',
                    sol: 'sol',
                    sosa: 'sosa',
                    soga: 'soga',
                    sosv: 'sosv',
                    sosvp: '$sosvp',
                }
            },
            {
                name: 'rankings',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/rankings/group',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                },
                basePath: '',
                rule: {
                    groupId: 'groupId',
                    indicator: 'indicator',
                    rank: 'rank',
                }
            },
        ],
        find: {
            baseUrl: process.env.VUE_APP_BJHSU_API,
            apiPrefix: '/api/rpes/',
            apiSuffix: 'accessKey=bjh-user-rpes',
            service: 'games/gameId',
            query: {
                groupId: 'groupId',
            },
            basePath: '0',
            rule: {
                gameId: 'gameId',
            }
        },
        map: {
            baseUrl: process.env.VUE_APP_HOCKEY_API,
            apiPrefix: '/hockey/',
            service: 'getBMGameBySourceGameId',
            query: {
                sourceGameId: 'gameId',
            },
            basePath: 'data',
            rule: {
                gameId: 'gameId',
                matchId: 'matchId'
            }
        },
    },
}

//--------------------------------------------------
// extends the Stats
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_icehockey_PlayerStatsGroup, Stats)

module.exports = tbs_model_vo_icehockey_PlayerStatsGroup